import { useRouter } from 'next/router';
import { useEffect, useMemo, useState } from 'react';
import { dateFormat } from 'utils/stringHelper';
import Image from 'next/image';

const logoUrl =
  'https://directus.onboardcrewapp.com/assets/4ee6af92-79a2-423f-812b-bdb75f239166';

const JobsViewIndex = ({ detail }) => {
  const router = useRouter();
  const [isCompanyWhitelisted, setIsCompanyWhitelisted] = useState(undefined);

  useEffect(() => {
    if (router.query?.notCompany === 'true') {
      setIsCompanyWhitelisted(false);
    } else {
      setIsCompanyWhitelisted(true);
    }
  }, [router, router.query?.notCompany]);

  const id = useMemo(
    () => (router.query?.id ? router.query?.id.toString() : ''),
    [router.query?.id]
  );

  if (isCompanyWhitelisted === undefined) {
    return (
      <div className='h-screen'>
        {/* <LoadingShip /> */}
      </div>
    )
  };

  return (
    <div className={`${isCompanyWhitelisted === false ? 'mt-72' : ''} max-w-screen-md w-full mx-auto px-20 py-40 ipad:px-40`}>
      <div className="pb-20 flex flex-col gap-40 w-full">
        <div className='relative'>
          <div>
            <div className='mb-24'>
              <div className='relative text-left flex flex-col items-baseline ipad:items-center ipad:flex-row gap-12'>
                <Image
                  src={detail?.company?.logo}
                  alt={`${detail?.company?.name} logo`}
                  width={0}
                  height={0}
                  sizes="100vw"
                  style={{
                    height: 'auto',
                    width: 'auto',
                    maxHeight: '40px',
                    maxWidth: '100%',
                    objectFit: 'contain',
                  }}
                />
                <p className="flex items-center gap-5">
                  <span className='font-medium'>{detail?.company?.name}</span>
                  <i className="ri-verified-badge-fill text-primary-light" />
                </p>
              </div>
            </div>
            <div className="mb-24">
              <p className="text-xxlarge3 ipad:text-subtitle3 font-semibold mb-8">{detail?.rank}</p>
              <p className="text-ink-lightest font-normal text-small3 mb-8">
                {detail?.certificate?.coc}
              </p>
              <div className="flex text-small3 mb-24 gap-8 flex-wrap">
                <div className="flex gap-2">
                  <p className="text-ink-lighter font-normal">
                    Apply before{' '}
                    <span className="text-ink-lighter font-semibold">
                      {dateFormat(detail?.expiry_date)}
                    </span>
                  </p>
                </div>
                <i className="ri-circle-fill text-[6px] text-grey-dark" />
                <p className="text-ink-lighter font-normal ">
                  Contract
                </p>
                <i className="ri-circle-fill text-[6px] text-grey-dark" />
                <p className="text-ink-lighter text-small3 font-normal ">
                  {detail?.contract_length} months
                </p>
              </div>
              <div className={`py-12 px-16 pb-4 rounded-lg ${isCompanyWhitelisted === false ? 'bg-primary/10' : 'bg-blue-100/60'}`}>
                <div className="flex flex-row gap-8 mb-16 text-ink-lighter text-small3">
                  <i className={`font-bold ri-luggage-deposit-line ${isCompanyWhitelisted === false ? 'text-primary' : 'text-blue-900'}`}></i>
                  <p className='text-ink-lighter font-light'>Min. {detail?.min_exp} years experience</p>
                </div>
                <div className="flex flex-row gap-8 mb-16 text-ink-lighter font-light text-small3">
                  <i className={`font-bold ri-map-pin-line ${isCompanyWhitelisted === false ? 'text-primary' : 'text-blue-900'}`}></i>
                  <p className='text-ink-lighter font-light'>Working area: <span className='font-semibold'>{detail?.working_area}</span></p>
                </div>
                <div className="flex flex-row gap-8 mb-16 text-ink-lighter font-light text-small3">
                  <i className={`font-bold ri-ship-line ${isCompanyWhitelisted === false ? 'text-primary' : 'text-blue-900'}`}></i>
                  <p className='text-ink-lighter font-light'>Vessel type: <span className='font-semibold'>{detail?.vessel_type}</span></p>
                </div>
                <div className="flex flex-row gap-8 mb-16 text-ink-lighter font-light text-small3">
                  <i className={`font-bold ri-flag-line ${isCompanyWhitelisted === false ? 'text-primary' : 'text-blue-900'}`}></i>
                  <p className='text-ink-lighter font-light'>Vessel flag: <span className='font-semibold'>{detail?.vessel_flag}</span></p>
                </div>
              </div>
            </div>
            <div className="mt-32 text-center">
              <button
                className={` ${isCompanyWhitelisted === false ? 'bg-primary' : 'bg-blue-900'
                  } p-16 w-full text-white rounded-full mb-16`}
                >
                <a
                  className={` ${isCompanyWhitelisted === false ? 'bg-primary' : 'bg-blue-900'
                    } p-16 w-full text-white rounded-full mb-16 font-medium text-small3 android:text-large3`}
                  href={`https://pxl.onboardcrewapp.com/apsf?url=https://onboard-app.onelink.me/2nPs/uigyh98r?page=job-detail&id=${id}`}
                  target='_blank'
                >Apply on OnBoard Crew App</a>
              </button>
              <div className="flex flex-row gap-2 items-center justify-center">
                <a href='/' target='_blank' className="text-ink-lightest text-small1 mb-16 flex gap-8 items-center">
                  Powered by
                  <Image
                    src={logoUrl}
                    alt={`OnBoard logo`}
                    width={0}
                    height={0}
                    sizes="100vw"
                    style={{
                      height: 'auto',
                      width: 'auto',
                      maxHeight: '15px',
                      maxWidth: '100%',
                      objectFit: 'contain',
                    }}
                  />
                </a>
              </div>
              {/* <div className='mt-32'>
                <p className='mb-12 text-ink-lighter text-small1'>Get the latest OnBoard App</p>
                <div className='flex gap-20 justify-center'>
                  <a href="https://apps.apple.com/id/app/onboard-crew-app/id6504788993" target='_blank'>
                    <Image src={LogoAppStore} alt="logo2" height={35} width={120} />
                  </a>
                  <a href="https://play.google.com/store/apps/details?id=com.onboard.android" target='_blank'>
                    <Image src={LogoGooglePlay} alt="logo2" height={35} width={120} />
                  </a>
                </div>
              </div> */}
            </div>
          </div>
          </div>
        <div>
          {/* SECTION 3: Job Description */}
          {detail?.description && (
            <div className="mb-24">
              <p className="text-xlarge2 font-medium mb-16">Job Description</p>
              <p className="text-ink-light text-small3 whitespace-pre-wrap break-words">{detail?.description || '-'}</p>
            </div>
          )}
          {/* SECTION 4: Certificates */}
          <div className="mb-24">
            <p className="text-xlarge2 font-medium mb-16">Required Certificates</p>
            {detail?.certificate?.cop?.length > 0 ? (
              <ul className="list-disc list-outside px-24">
                {detail?.certificate?.cop
                  ?.filter((x) => x !== null)
                  .map((x, index) => (
                    <li key={index} className="text-ink-light text-small3 p-4">
                      {x}
                    </li>
                  ))}
              </ul>
            ) : <div>-</div>}
          </div>

          <div className="border-t border-grey my-40"></div>

          <div className="mb-24">
            <p className="text-xlarge2 font-medium mb-16">About Company</p>
            <div className="p-24 bg-grey-lightest rounded-xl">
              <div className="mb-8">
                <Image
                  src={detail?.company?.logo}
                  alt={`${detail?.company?.name} logo`}
                  width={0}
                  height={0}
                  sizes="100vw"
                  style={{
                    height: 'auto',
                    width: 'auto',
                    maxHeight: '40px',
                    maxWidth: '100%',
                    objectFit: 'contain',
                  }}
                />
              </div>
              <div className="flex flex-row items-center gap-4 mb-12">
                <p className="text-ink font-semibold">{detail?.company?.name}</p>
                <i className="ri-verified-badge-fill text-primary-light" />
              </div>
              <div className="mb-12">
                <p className="text-ink-lightest text-small3">Company Type</p>
                <p className="text-ink">{detail?.company?.type}</p>
              </div>
              <div className="mb-12">
                <p className="text-ink-lightest text-small3">Employees</p>
                <p className="text-ink">{detail?.company?.employee}</p>
              </div>
              <div className="mb-12">
                <p className="text-ink-lightest text-small3">Industries</p>
                <p className="text-ink">{detail?.company?.industries}</p>
              </div>
              <div className="mb-12">
                <p className="text-ink-lightest text-small3">Location</p>
                <p className="text-ink">{detail?.company?.country}</p>
              </div>
              <div className="border-t border-grey my-28"></div>
              <div>
                <p className="text-xlarge2 font-medium mb-16">Company Description</p>
                <p className='text-regular3 font-light'>{detail?.company?.about}</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="mb-32 text-center">
        <button
          className={` ${isCompanyWhitelisted === false ? 'bg-primary' : 'bg-blue-900'
            } p-16 w-full text-white rounded-full mb-16`}
        >
          <a
            className={` ${isCompanyWhitelisted === false ? 'bg-primary' : 'bg-blue-900'
              } p-16 w-full text-white rounded-full mb-16 font-medium text-small3 android:text-large3`}
            href={`https://pxl.onboardcrewapp.com/apsf?url=https://onboard-app.onelink.me/2nPs/uigyh98r?page=job-detail&id=${id}`}
            target='_blank'
          >Apply on OnBoard Crew App</a>
        </button>
        <div className="flex flex-row gap-2 items-center justify-center">
          <a href='/' target='_blank' className="text-ink-lightest text-small1 mb-16 flex gap-8 items-center">
            Powered by
            <Image
              src={logoUrl}
              alt={`OnBoard logo`}
              width={0}
              height={0}
              sizes="100vw"
              style={{
                height: 'auto',
                width: 'auto',
                maxHeight: '15px',
                maxWidth: '100%',
                objectFit: 'contain',
              }}
            />
          </a>
        </div>
        {/* <div className='mt-32'>
                <p className='mb-12 text-ink-lighter text-small1'>Get the latest OnBoard App</p>
                <div className='flex gap-20 justify-center'>
                  <a href="https://apps.apple.com/id/app/onboard-crew-app/id6504788993" target='_blank'>
                    <Image src={LogoAppStore} alt="logo2" height={35} width={120} />
                  </a>
                  <a href="https://play.google.com/store/apps/details?id=com.onboard.android" target='_blank'>
                    <Image src={LogoGooglePlay} alt="logo2" height={35} width={120} />
                  </a>
                </div>
              </div> */}
      </div>
    </div>
  );
};

export default JobsViewIndex;
